<br />

<mat-card appearance="outlined">

    <mat-card-header>
        <mat-card-title><img src="/assets/img/prestalia.png" width="100px"></mat-card-title>
        <mat-card-subtitle><p class="subtitle">Esperance pour Haiti</p></mat-card-subtitle>
        <mat-card-subtitle><p><small>LOGIN</small></p></mat-card-subtitle>
        <mat-card-subtitle><mat-error>{{ form.getError('backend') }}</mat-error></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

        <br />

        <form [formGroup]="form" (ngSubmit)="login()">

            <div>
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="usr">
                    <mat-error *ngIf="form.get('usr')?.hasError('required')">Required field</mat-error>
                    <mat-error *ngIf="form.get('usr')?.hasError('email')">Invalid email</mat-error>
                </mat-form-field>
            </div>
        
            <div>
                <mat-form-field>
                    <mat-label>Password</mat-label>
                    <input matInput formControlName="pwd" [type]="hide ? 'password' : 'text'">
                    <button mat-icon-button matSuffix (click)="hide = !hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="form.get('pwd')?.hasError('required')">Required field</mat-error>
                </mat-form-field>
            </div>

            <br />
        
            <button mat-flat-button color="primary" type="submit">LOGIN</button>
        
        </form>

    </mat-card-content>

    <br />

    <mat-card-actions>
        <button mat-button routerLink="/pwd-recovery">PASSWORD RECOVERY</button>
    </mat-card-actions>

</mat-card>
